const patientBase = '/patient-2';

export const PatientRoutes = {
  HOME: `${patientBase}/`,
  ADD: `${patientBase}/add`,
  EDIT: `${patientBase}/edit/:id`,
  getFiles: (patientId: string | number) => `${patientBase}/edit/${patientId}/files`,
  getFileView: (patientId: string | number, fileId: string | number) => `${patientBase}/edit/${patientId}/files/${fileId}`,
  getFileViewInWorklist: (patientId: string | number, worklistSlug: string, fileId: string | number) =>
    `${patientBase}/edit/${patientId}/files/${worklistSlug}/file/${fileId}`,
  getFilesWithPath: (patientId: string | number, hierarchicalPath: string) => `${patientBase}/edit/${patientId}/files/${hierarchicalPath}`,
};
